/**
 *	map-ready.reducer.js
 */

export default function(state = false, action = {}) {

    switch (action.type) {

        case 'SET_MAP_READY':
			return action.mapReady;

        default:
            return state;
    }
}